import { Injectable } from '@angular/core';
import { LegacyGender } from '../constants-types/Enums';
import { BehavioralReportConfiguration } from '../core-data-model/BehavioralReportConfiguration.model';
import { AbstractReportReceiver } from '../core-services/AbstractReport';
import { JobApi } from '../core-services/JobApi/JobApi.connect';
import { PersonApi } from '../core-services/PersonApi.connect';
import { PdfReference } from '../system-services/PdfReference';

@Injectable({
    providedIn: 'root'
})
export class PdfsDataService {
    constructor(
        private jobsApi: JobApi,
        private personsApi: PersonApi
    ) {}

    getBehavioralReportPdfs(
        recipients: AbstractReportReceiver[],
        reportConfig: BehavioralReportConfiguration
    ) {
        const personInfo: { personId: string; gender: string }[] = [];
        recipients.forEach((receiver) => {
            personInfo.push({
                personId: receiver.id,
                gender: LegacyGender[receiver.gender]
            });
        });

        return this.personsApi.getBehavioralReports(
            personInfo,
            'Print',
            reportConfig
        );
    }

    getPlacardPdfs(
        recipients: AbstractReportReceiver[],
        languageLocale: string
    ) {
        const personsToReport: string[] = [];
        recipients.forEach((receiver) => {
            personsToReport.push(receiver.id);
        });
        return this.personsApi.getPlacardPdf(
            personsToReport,
            'Print',
            undefined,
            languageLocale
        );
    }

    getPdcPdfs(recipients: AbstractReportReceiver[], languageLocale: string) {
        const personsToReport: string[] = [];
        recipients.forEach((receiver) => {
            personsToReport.push(receiver.id);
        });
        return this.personsApi.getPdcPdf(
            personsToReport,
            'Print',
            undefined,
            languageLocale
        );
    }

    getMdcPdfs(recipients: AbstractReportReceiver[], languageLocale: string) {
        const personsToReport: string[] = [];
        recipients.forEach((receiver) => {
            personsToReport.push(receiver.id);
        });
        return this.personsApi.getMdcPdf(
            personsToReport,
            'Print',
            undefined,
            languageLocale
        );
    }

    getMsgPdfs(recipients: AbstractReportReceiver[], languageLocale: string) {
        const personsToReport: string[] = [];
        recipients.forEach((receiver) => {
            personsToReport.push(receiver.id);
        });
        return this.personsApi.getMsgPdf(
            personsToReport,
            'Print',
            undefined,
            languageLocale
        );
    }

    getJobReportPdfs(
        jobs: string[],
        includeCognitive = true,
        languageLocale: string
    ): Promise<PdfReference> {
        return this.jobsApi.getJobReportV2Bulk(
            jobs,
            includeCognitive,
            languageLocale
        );
    }

    getCogReportPdfs(
        persons: string[],
        languageLocale: string,
        showSensitiveInfo = true
    ): Promise<PdfReference> {
        return this.personsApi.getCogReportBulk(
            persons,
            showSensitiveInfo,
            languageLocale
        );
    }

    getBAReportPdfs(
        persons: { personId: string; gender: string }[],
        reportConfig: BehavioralReportConfiguration
    ): Promise<PdfReference> {
        return this.personsApi.getBAReportBulk(persons, reportConfig);
    }
}
